import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, mergeProps as _mergeProps, withKeys as _withKeys, withModifiers as _withModifiers } from "vue";
const _hoisted_1 = ["src"];
const _hoisted_2 = {
    key: 1,
    class: "mg-chat-hover"
};
const _hoisted_3 = ["src"];
const _hoisted_4 = { class: "messagesCanvas" };
const _hoisted_5 = ["src"];
const _hoisted_6 = ["innerHTML"];
const _hoisted_7 = { key: 0 };
import { ref, computed, watch, onMounted, nextTick, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useDarkMode } from '@/composables/useDarkMode';
import { useCustomer } from '@/composables/useCustomer';
import { useChat } from '@/composables/useChat';
import { useApi } from '@/composables/useApi';
import { getHttpInstance, getApiConfig } from '@/composables/useApi';
import SimpleDrawerPanel from '@/components/elements/SimpleDrawerPanel.vue';
const idleTimeout = 20000;
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatMgButton',
    props: {
        prompt: {},
        bottom: {},
        icon: {},
        hover: { type: Boolean },
        initialPrompt: { type: Boolean },
        size: {}
    },
    setup(__props, { expose: __expose }) {
        const props = __props;
        const router = useRouter();
        const state = useAppState();
        const { isDarkMode } = useDarkMode();
        const { getCustomer } = useCustomer();
        const { sendChatMessage } = useChat();
        const { signalV1 } = useApi();
        const instance = getCurrentInstance();
        const whatsAppNumber = instance?.appContext.config.globalProperties.$whatsAppNumber || '';
        const endRef = ref(null);
        const cachedVoices = ref([]);
        if (window.speechSynthesis) {
            cachedVoices.value = window.speechSynthesis.getVoices();
            window.speechSynthesis.onvoiceschanged = () => {
                cachedVoices.value = window.speechSynthesis.getVoices();
            };
        }
        const drawer = ref(false);
        const message = ref(null);
        const messages = ref([]);
        const typing = ref(false);
        const bottomPos = ref("19%");
        const promptSent = ref(true); // Disable initial prompt
        let inputIdleTimer = null;
        const idlePromptShown = ref(false);
        const userHasTyped = ref(false);
        const lastWhatsAppSentIndex = ref(0);
        const prompts = [
            "Feel free to ask me anything, don't be shy 😊",
            "What can I help you with today?",
            "Ask away!",
            "How can I assist you today?",
            "What's on your mind today? 🧠",
            "I'm here to help with your financial questions. 🙋‍♀️",
            "Let's talk about your goals and how I can assist you.",
            "Let's talk finances. 💬",
            "Here to help with your financial journey. 🛤️",
            "I'm ready when you are. ✅",
            "You wait - time passes. ⏳",
            "How can I help you manage your money? 🤝",
            "Ask me anything about your finances. 🤔",
            "Your financial well-being is my priority. 💼",
            "Let's work together to achieve your financial goals."
        ];
        const hasUnsentMessages = computed(() => {
            return messages.value.slice(lastWhatsAppSentIndex.value).some(m => !m.whatsAppConfirmation);
        });
        function toggleDrawer() {
            drawer.value = !drawer.value;
        }
        let chatTouchStart = null;
        watch(drawer, (open) => {
            if (open) {
                document.body.classList.add('hide-nav-bar');
                idlePromptShown.value = false;
                userHasTyped.value = false;
                resetInputIdleTimer();
                if (props.initialPrompt) {
                    promptSent.value = false;
                }
                if (props.prompt && !promptSent.value) {
                    console.log('Sending initial prompt:', props.prompt);
                    promptSent.value = true;
                    sendMessageAndWaitForResponse(props.prompt, false);
                }
                // Stop iOS from scrolling the page when focusing the chat input.
                chatTouchStart = (e) => {
                    const target = e.target;
                    const wrapper = target?.closest('.chatInput');
                    if (!wrapper)
                        return;
                    const input = wrapper.querySelector('input');
                    if (!input || input === document.activeElement)
                        return;
                    e.preventDefault();
                    input.focus({ preventScroll: true });
                };
                document.addEventListener('touchstart', chatTouchStart, { passive: false });
            }
            else {
                document.body.classList.remove('hide-nav-bar');
                if (inputIdleTimer)
                    clearTimeout(inputIdleTimer);
                if (chatTouchStart) {
                    document.removeEventListener('touchstart', chatTouchStart);
                    chatTouchStart = null;
                }
            }
        });
        function onKeyPress(event) {
            if (!userHasTyped.value && event.key.length === 1 && event.key.match(/\S/)) {
                userHasTyped.value = true;
            }
            if (event.key === "Enter") {
                if (!message.value || message.value.trim() === "") {
                    event.preventDefault();
                    return;
                }
                showSentMessage();
                sendMessageAndWaitForResponse(message.value);
                message.value = "";
                idlePromptShown.value = false;
            }
        }
        function scrollToEnd() {
            nextTick(() => {
                if (endRef.value) {
                    endRef.value.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
        function showSentMessage() {
            messages.value.push({ direction: "out", body: message.value });
            typing.value = true;
            scrollToEnd();
        }
        function sendMessageAndWaitForResponse(msg, store = true) {
            if (msg.toLowerCase() == "litmustest") {
                router.push('/litmustestpage');
                return;
            }
            if (msg.toLowerCase() == "allownoti") {
                signalV1("enableNotifications", "", "", "", "activity");
                return;
            }
            if (msg.toLowerCase() == "testpage") {
                router.push('/test');
                return;
            }
            if (msg.toLowerCase() == "hiddensettings") {
                let current = localStorage.getItem('showHiddenSettings') === 'true';
                localStorage.setItem('showHiddenSettings', (!current).toString());
                localStorage.setItem('useLocalCache', 'true');
                localStorage.setItem('useCachedEndpoints', 'true');
                router.push('/');
                return;
            }
            if (msg.toLowerCase() == "speak") {
                let current = localStorage.getItem('speak') === 'true';
                localStorage.setItem('speak', (!current).toString());
                return;
            }
            if (msg.toLowerCase() == "payslips") {
                localStorage.setItem('showPayslips', 'true');
                router.push('/payslips');
                return;
            }
            if (msg.toLowerCase() == "spendingtreemap") {
                router.push('/spendingtreemap');
                return;
            }
            if (msg.toLowerCase() == "admin") {
                router.push('/admin');
                return;
            }
            if (msg.toLowerCase() == "chatpage") {
                router.push('/chat');
                return;
            }
            const voucherCardMatch = msg.toLowerCase().match(/^vouchercard([1-4])$/);
            if (voucherCardMatch) {
                localStorage.setItem('showNewVoucherCard', 'true');
                window.location.href = '/#/?voucherState=' + voucherCardMatch[1];
                window.location.reload();
                return;
            }
            if (msg.toLowerCase() == "vouchercard") {
                localStorage.setItem('showNewVoucherCard', 'true');
                window.location.href = '/#/';
                window.location.reload();
                return;
            }
            if (msg.toLowerCase() == "vouchercardoff") {
                localStorage.setItem('showNewVoucherCard', 'false');
                window.location.href = '/#/';
                window.location.reload();
                return;
            }
            const quizTestMatch = msg.toLowerCase().match(/^test question (\d+)$/);
            if (quizTestMatch) {
                router.push({ path: '/', query: { quiztest: 'true', q: quizTestMatch[1] } });
                return;
            }
            typing.value = true;
            sendChatMessage(msg, (res) => {
                if (!res.keepThinking) {
                    typing.value = false;
                }
                var messageIn = res.body.replaceAll("**", '');
                messages.value.push({ direction: "in", body: messageIn, store: store });
                if (localStorage.getItem('speak') === 'true') {
                    const utterance = new SpeechSynthesisUtterance(messageIn);
                    utterance.rate = 0.9;
                    utterance.pitch = 0.8;
                    utterance.voice = cachedVoices.value.find(voice => voice.lang === 'en-GB') || null;
                    window.speechSynthesis.speak(utterance);
                }
                scrollToEnd();
            });
        }
        function sendMessage() {
            if (message.value && !typing.value) {
                showSentMessage();
                sendMessageAndWaitForResponse(message.value);
                message.value = "";
                idlePromptShown.value = false;
                userHasTyped.value = true;
                resetInputIdleTimer();
            }
        }
        function onLoad() {
            if (props.bottom) {
                bottomPos.value = props.bottom;
            }
            messages.value.push({ direction: "in", body: "Please remember, the Digital Financial Assistant provides factual information to help you make informed decisions. " +
                    "Any specific actions it may suggest should be taken as guidance, and not advice." });
            lastWhatsAppSentIndex.value = messages.value.length;
            getCustomer(() => { });
        }
        function formatMessage(text) {
            if (!text)
                return '';
            let html = text
                .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
                .replace(/\*([^*]+)\*/g, '<em>$1</em>');
            html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
            html = html.replace(/(<br>)+\s*(\d+\.) /g, '<br>$2 ');
            html = html.replace(/\n\s*- /g, '<br>&bull; ');
            html = html.replace(/\n/g, '<br>');
            return html;
        }
        function processMonetaryAmounts(text) {
            if (localStorage.getItem('randomiseFigures') !== 'true') {
                return text;
            }
            const monetaryPattern = /(?:£|$)(?:\d{1,3}(?:,\d{3})*(?:\.\d{2})?|\d+(?:\.\d{2})?)|(?:\d+(?:\.\d{2})?\s*(?:pounds?|pence|p|GBP|USD))/gi;
            return text.replace(monetaryPattern, (match) => {
                if (match.startsWith('£') || match.startsWith('$')) {
                    return match.charAt(0) + '####';
                }
                else {
                    return '####' + match.replace(/^\d+(?:\.\d{2})?/, '');
                }
            });
        }
        function applyMonetaryMask(text) {
            if (localStorage.getItem('randomiseFigures') === 'true') {
                return processMonetaryAmounts(text);
            }
            return text;
        }
        function resetInputIdleTimer() {
            if (inputIdleTimer)
                clearTimeout(inputIdleTimer);
            if (idlePromptShown.value || userHasTyped.value)
                return;
            inputIdleTimer = setTimeout(() => {
                if (!typing.value && (!message.value || message.value.trim() === '') && !idlePromptShown.value && drawer.value && !userHasTyped.value) {
                    typing.value = true;
                    setTimeout(() => {
                        typing.value = false;
                        messages.value.push({ direction: "in", body: prompts[Math.floor(Math.random() * prompts.length)] });
                        idlePromptShown.value = true;
                        scrollToEnd();
                    }, 2000);
                }
            }, idleTimeout);
        }
        function sendWhatsAppNotification(body, phoneNumber) {
            const request = {
                body: body,
                whatsApp: true,
                whatsAppTemplate: false,
                phoneNumber: phoneNumber
            };
            getHttpInstance().post(getApiConfig().api + "/Customers/00000000-0000-0000-0000-000000000000/Notifications", request)
                .catch((result) => {
                console.log(result, 'WhatsApp notification error');
            });
        }
        function attach() {
            if (state.customer) {
                if (state.customer.person.whatsAppEnabled) {
                    messages.value.push({ direction: "in", body: "Check your WhatsApp!" });
                    scrollToEnd();
                    sendWhatsAppNotification("You indicated you wanted to send a document 📄  Just drop it here and we will upload and process it for you 👍", state.customer.person.mobilePhone);
                    window.location.href = `https://wa.me/${whatsAppNumber}`;
                }
                else {
                    router.push('/enablewhatsapp');
                }
            }
        }
        function sendToWhatsApp() {
            if (state.customer) {
                if (state.customer.person.whatsAppEnabled) {
                    var newMessages = messages.value.slice(lastWhatsAppSentIndex.value).filter(m => !m.whatsAppConfirmation);
                    if (newMessages.length === 0)
                        return;
                    var conversation = newMessages.map((m) => {
                        return (m.direction === 'out' ? 'You' : 'MG') + ': ' + m.body;
                    }).join('\n');
                    lastWhatsAppSentIndex.value = messages.value.length;
                    messages.value.push({ direction: "in", body: "Conversation sent to your WhatsApp!", whatsAppConfirmation: true });
                    scrollToEnd();
                    sendWhatsAppNotification('Conversation saved from MGChat:\n\n' + conversation, state.customer.person.mobilePhone);
                    window.location.href = `https://wa.me/${whatsAppNumber}`;
                }
                else {
                    router.push('/#/enablewhatsapp');
                }
            }
        }
        onMounted(() => {
            onLoad();
            watch(message, () => {
                resetInputIdleTimer();
            });
        });
        __expose({ toggleDrawer });
        return (_ctx, _cache) => {
            const _component_v_btn = _resolveComponent("v-btn");
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            const _component_v_text_field = _resolveComponent("v-text-field");
            return (_openBlock(), _createElementBlock("div", {
                onClick: _cache[4] || (_cache[4] = _withModifiers(() => { }, ["stop"]))
            }, [
                (!_ctx.hover && !drawer.value)
                    ? (_openBlock(), _createElementBlock("img", {
                        key: 0,
                        class: "headerImage",
                        style: _normalizeStyle(_ctx.size ? `width: ${_ctx.size}px` : ''),
                        src: _ctx.icon ? _ctx.icon : (_unref(isDarkMode) ? require('@/assets/AIChat.png') : require('@/assets/AI-Chat-24px.svg')),
                        onClick: toggleDrawer
                    }, null, 12, _hoisted_1))
                    : _createCommentVNode("", true),
                (_ctx.hover && !drawer.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                        _createVNode(_component_v_btn, {
                            class: "imgButton",
                            variant: "text",
                            onClick: toggleDrawer,
                            style: _normalizeStyle('bottom: ' + bottomPos.value + ' !important;')
                        }, {
                            default: _withCtx(() => [
                                _createElementVNode("img", {
                                    src: _ctx.icon ? _ctx.icon : require('@/assets/ChatMgButton.png')
                                }, null, 8, _hoisted_3)
                            ]),
                            _: 1
                        }, 8, ["style"])
                    ]))
                    : _createCommentVNode("", true),
                _createVNode(SimpleDrawerPanel, {
                    modelValue: drawer.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((drawer).value = $event)),
                    title: "Chat MG",
                    direction: "right"
                }, {
                    footer: _withCtx(() => [
                        _createElementVNode("div", {
                            class: "inputBarInner",
                            onClick: _cache[2] || (_cache[2] = event => { event.stopPropagation(); })
                        }, [
                            _createVNode(_component_v_text_field, {
                                modelValue: message.value,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((message).value = $event)),
                                class: _normalizeClass(["chatInput", { 'chatInputShrink': message.value && message.value.trim() !== '' }]),
                                type: "text",
                                placeholder: "Enter your message",
                                onKeypress: onKeyPress,
                                "hide-details": "",
                                onKeyup: _withKeys(sendMessage, ["enter"]),
                                variant: "solo",
                                flat: true,
                                "single-line": "",
                                outlined: "",
                                rounded: "",
                                dense: "",
                                key: "input"
                            }, {
                                "prepend-inner": _withCtx(() => [
                                    _createVNode(_component_v_menu, { location: "top" }, {
                                        activator: _withCtx(({ props: menuProps }) => [
                                            _createVNode(_component_v_icon, _mergeProps(menuProps, {
                                                class: 'sendIcon',
                                                style: { "font-size": "24px", "margin-right": "10px", "color": "#8c8897" }
                                            }), {
                                                default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                    _createTextVNode("mdi-plus-circle-outline")
                                                ])),
                                                _: 2
                                            }, 1040)
                                        ]),
                                        default: _withCtx(() => [
                                            _createVNode(_component_v_list, {
                                                density: "compact",
                                                style: { "min-width": "180px" }
                                            }, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_list_item, { onClick: attach }, {
                                                        prepend: _withCtx(() => [
                                                            _createVNode(_component_v_icon, { style: { "color": "#8c8897" } }, {
                                                                default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                                    _createTextVNode("mdi-paperclip")
                                                                ])),
                                                                _: 1
                                                            })
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => _cache[8] || (_cache[8] = [
                                                                    _createTextVNode("Attach document")
                                                                ])),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_list_item, {
                                                        onClick: sendToWhatsApp,
                                                        disabled: !hasUnsentMessages.value
                                                    }, {
                                                        prepend: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                                style: _normalizeStyle('color: ' + (hasUnsentMessages.value ? '#25D366' : '#e2e0e8'))
                                                            }, {
                                                                default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                                    _createTextVNode("mdi-whatsapp")
                                                                ])),
                                                                _: 1
                                                            }, 8, ["style"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_list_item_title, null, {
                                                                default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                                    _createTextVNode("Save this chat to WhatsApp")
                                                                ])),
                                                                _: 1
                                                            })
                                                        ]),
                                                        _: 1
                                                    }, 8, ["disabled"])
                                                ]),
                                                _: 1
                                            })
                                        ]),
                                        _: 1
                                    })
                                ]),
                                "append-inner": _withCtx(() => [
                                    _createVNode(_component_v_icon, {
                                        class: _normalizeClass('sendIcon'),
                                        color: message.value && message.value.trim() !== '' ? '#8c8897' : '#e2e0e8',
                                        onClick: _cache[0] || (_cache[0] = ($event) => (message.value && message.value.trim() !== '' ? sendMessage() : null)),
                                        style: { "font-size": "24px" }
                                    }, {
                                        default: _withCtx(() => _cache[11] || (_cache[11] = [
                                            _createTextVNode("mdi-send-outline")
                                        ])),
                                        _: 1
                                    }, 8, ["color"])
                                ]),
                                _: 1
                            }, 8, ["modelValue", "class"])
                        ])
                    ]),
                    default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(messages.value, (m) => {
                                return (_openBlock(), _createElementBlock("div", { key: m }, [
                                    _createElementVNode("div", {
                                        class: _normalizeClass('message ' + m.direction)
                                    }, [
                                        (m.direction === 'in')
                                            ? (_openBlock(), _createElementBlock("img", {
                                                key: 0,
                                                class: "message-avatar",
                                                src: require('@/assets/mg.png'),
                                                alt: "MG"
                                            }, null, 8, _hoisted_5))
                                            : _createCommentVNode("", true),
                                        _createElementVNode("div", {
                                            class: "message-content",
                                            innerHTML: formatMessage(applyMonetaryMask(m.body))
                                        }, null, 8, _hoisted_6)
                                    ], 2)
                                ]));
                            }), 128)),
                            (typing.value)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_7, _cache[5] || (_cache[5] = [
                                    _createElementVNode("div", { class: "message in typingIndicator" }, [
                                        _createElementVNode("span", { class: "typingDots" }, [
                                            _createElementVNode("span"),
                                            _createElementVNode("span"),
                                            _createElementVNode("span")
                                        ])
                                    ], -1)
                                ])))
                                : _createCommentVNode("", true),
                            _createElementVNode("div", {
                                style: { "clear": "both" },
                                ref_key: "endRef",
                                ref: endRef
                            }, null, 512)
                        ])
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ]));
        };
    }
});
